// extracted by mini-css-extract-plugin
export default {"cell":"Cell_cell__OQgWe","cell-content":"Cell_cell-content__PXYbd","bold":"Cell_bold__67mdA","right":"Cell_right__Ybani"};